import { useTranslation } from 'react-i18next';
import { useAllPicUserOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const InfluencerManagementPICField = (
  props: Omit<MultipleSelectorFieldProps<MarketplaceFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allPicsUserOptions } = useAllPicUserOptions({ fetchPolicy: 'cache-first' });

  return (
    <SelectorField
      hasSelectAll={false}
      options={allPicsUserOptions}
      title={t('Selector.Influencer Management PIC')}
      help={t('Tooltip.Influencer Management PIC')}
      name={MarketplaceFormKeys.influencerManagementPicIds}
      multiple
      {...props}
    />
  );
};
